import { motion } from 'framer-motion'
import styled from 'styled-components/macro'

import { styleReset } from 'styles/misc'
import { mq } from 'styles/mq'

export const Container = styled.section`
  display: flex;
  flex-direction: column;

  ${mq.medium} {
    position: sticky;
    top: var(--container-spacing);
    height: calc(100vh - 2 * var(--container-spacing));
  }
`

export const List = styled.ul`
  display: flex;
  flex-direction: column;
  list-style: none;
  padding: 0;
  margin: 0;
  gap: 1rem;
  overflow: hidden;

  ${mq.medium} {
    height: 0;
    flex-grow: 1;
  }
`

export const FilterItem = styled(motion.li)`
  color: white;
  border-radius: 1rem;
  flex-shrink: 0;
  overflow: hidden;
  background-color: var(--text-color);

  &[data-filter='military'] {
    background-color: #3b6986;
  }

  &[data-filter='year'] {
    background-color: #7997a7;
  }

  &[data-open='true'] {
    flex-shrink: 10;
  }
`

export const ToggleWrapper = styled.div`
  position: relative;
`

export const Toggle = styled(motion.button)`
  ${styleReset}
  display: flex;
  align-items: center;
  width: 100%;
  padding: 1rem 1.1rem 1rem 0.5rem;
  transition: 0.2s background-color;
  flex-shrink: 0;
  cursor: pointer;

  &:hover {
    background-color: rgba(255, 255, 255, 0.15);
  }

  &::before {
    content: '';
    display: block;
    width: 1.8rem;
    margin: -1.2rem 0.5rem -1rem 0.7rem;
    aspect-ratio: 1;
    flex-shrink: 0;
    background: url("data:image/svg+xml,%3Csvg width='18' height='18' viewBox='0 -2 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M8.45187 14.011C8.5663 14.2049 8.7748 14.3239 9 14.3239C9.2252 14.3239 9.4337 14.2049 9.54813 14.011L10.2455 12.8312C11.6689 10.4254 13.0136 8.15206 13.4848 7.21161C13.4854 7.21051 13.486 7.2094 13.4866 7.20829C13.4903 7.20124 13.4941 7.19409 13.4975 7.18694C13.8308 6.5021 14 5.76633 14 5C14 2.24297 11.757 0 9 0C6.24297 0 4 2.24297 4 5C4 5.76681 4.16918 6.50274 4.50532 7.19204C4.96766 8.12007 6.32095 10.4081 7.75398 12.8306L8.45187 14.011ZM6.55396 4.82398C6.55396 6.17265 7.65133 7.26986 9 7.26986C10.3487 7.26986 11.4459 6.17265 11.4459 4.82398C11.4459 3.4753 10.3487 2.37793 9 2.37793C7.65133 2.37793 6.55396 3.4753 6.55396 4.82398Z' fill='white'/%3E%3C/svg%3E%0A")
      center center / contain no-repeat;
  }

  &::after {
    content: '';
    display: block;
    width: 0.8rem;
    height: 0.8rem;
    margin-inline: auto 0.5rem;
    border-right: 2px solid currentColor;
    border-bottom: 2px solid currentColor;
    transform: translateY(-20%) rotate(45deg);
    transition: 0.3s transform;
  }

  [data-filter='military'] &::before {
    background-image: url("data:image/svg+xml,%3Csvg width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M9.03463 1.0444L10.7322 6.44041L16.0525 6.42775L11.7611 9.72119L13.4364 15.0792L9.06801 11.784L4.71793 15.1097L6.36124 9.73833L2.05105 6.47446L7.36995 6.45162L9.03463 1.0444Z' fill='white'/%3E%3C/svg%3E%0A");
  }

  [data-filter='year'] &::before {
    background-image: url("data:image/svg+xml,%3Csvg width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M5.794 2H5.45652C5.41346 2 5.37262 2.00905 5.33306 2.02191C5.13538 2.08602 4.98926 2.29706 4.98926 2.55022V2.78253V3.37716V3.68652C4.98926 3.74401 4.99883 3.79832 5.01273 3.85032C5.07221 4.07369 5.24726 4.23674 5.45652 4.23674H5.794C6.05212 4.23674 6.26127 3.99043 6.26127 3.68652V3.37716V2.78253V2.55022C6.26127 2.24631 6.05212 2 5.794 2Z' fill='white'/%3E%3Cpath d='M12.4366 2H12.0991C11.841 2 11.6318 2.24631 11.6318 2.55022V2.78253V3.37716V3.68652C11.6318 3.99043 11.841 4.23674 12.0991 4.23674H12.4366C12.6947 4.23674 12.9038 3.99043 12.9038 3.68652V3.37716V2.78253V2.55022C12.9037 2.24631 12.6946 2 12.4366 2Z' fill='white'/%3E%3Cpath d='M14.1602 3.37695H13.3246V3.68632C13.3246 4.2219 12.9261 4.65759 12.4363 4.65759H12.0988C11.6091 4.65759 11.2105 4.2219 11.2105 3.68632V3.37695H6.68211V3.68632C6.68211 4.2219 6.28358 4.65759 5.79379 4.65759H5.45631C4.9665 4.65759 4.56799 4.2219 4.56799 3.68632V3.37695H3.8399C3.37612 3.37695 3 3.72958 3 4.16433V14.6509C3 15.0864 3.3761 15.4382 3.8399 15.4382H14.1601C14.6243 15.4382 15 15.0863 15 14.6509V4.16444C15.0001 3.72969 14.6244 3.37695 14.1602 3.37695ZM13.8998 14.2824L4.06968 14.2787V5.82432H13.8998V14.2824Z' fill='white'/%3E%3Cpath d='M10.0529 7.86184H12.6382C12.8626 7.86184 13.0441 7.63774 13.0441 7.36078C13.0441 7.08382 12.8625 6.85973 12.6382 6.85973H10.0529C9.82847 6.85973 9.64697 7.08382 9.64697 7.36078C9.64697 7.63763 9.82845 7.86184 10.0529 7.86184Z' fill='white'/%3E%3Cpath d='M10.0529 9.67185H12.6382C12.8626 9.67185 13.0441 9.44775 13.0441 9.17079C13.0441 8.89385 12.8625 8.66975 12.6382 8.66975H10.0529C9.82847 8.66975 9.64697 8.89385 9.64697 9.17079C9.64697 9.44775 9.82845 9.67185 10.0529 9.67185Z' fill='white'/%3E%3Cpath d='M10.0529 11.4819H12.6382C12.8626 11.4819 13.0441 11.2578 13.0441 10.9808C13.0441 10.7039 12.8625 10.4798 12.6382 10.4798H10.0529C9.82847 10.4798 9.64697 10.7039 9.64697 10.9808C9.64697 11.2578 9.82845 11.4819 10.0529 11.4819Z' fill='white'/%3E%3Cpath d='M10.0529 13.2919H12.6382C12.8626 13.2919 13.0441 13.0678 13.0441 12.7909C13.0441 12.5139 12.8625 12.2898 12.6382 12.2898H10.0529C9.82847 12.2898 9.64697 12.5139 9.64697 12.7909C9.64697 13.0678 9.82845 13.2919 10.0529 13.2919Z' fill='white'/%3E%3Cpath d='M5.47378 7.86184H8.05905C8.28346 7.86184 8.46494 7.63774 8.46494 7.36078C8.46494 7.08382 8.28335 6.85973 8.05905 6.85973H5.47378C5.24935 6.85973 5.06787 7.08382 5.06787 7.36078C5.06789 7.63763 5.24935 7.86184 5.47378 7.86184Z' fill='white'/%3E%3Cpath d='M5.47378 9.67185H8.05905C8.28346 9.67185 8.46494 9.44775 8.46494 9.17079C8.46494 8.89385 8.28335 8.66975 8.05905 8.66975H5.47378C5.24935 8.66975 5.06787 8.89385 5.06787 9.17079C5.06789 9.44775 5.24935 9.67185 5.47378 9.67185Z' fill='white'/%3E%3Cpath d='M5.47378 11.4819H8.05905C8.28346 11.4819 8.46494 11.2578 8.46494 10.9808C8.46494 10.7039 8.28335 10.4798 8.05905 10.4798H5.47378C5.24935 10.4798 5.06787 10.7039 5.06787 10.9808C5.06787 11.2578 5.24935 11.4819 5.47378 11.4819Z' fill='white'/%3E%3Cpath d='M5.47378 13.2919H8.05905C8.28346 13.2919 8.46494 13.0678 8.46494 12.7909C8.46494 12.5139 8.28335 12.2898 8.05905 12.2898H5.47378C5.24935 12.2898 5.06787 12.5139 5.06787 12.7909C5.06789 13.0678 5.24935 13.2919 5.47378 13.2919Z' fill='white'/%3E%3C/svg%3E%0A");
  }

  [data-open='true'] &::after {
    transform: translateY(20%) rotate(225deg);
  }
`

export const ClearButton = styled.button`
  --size: 1.2em;
  --padding: 0.4em;

  ${styleReset}
  position: absolute;
  top: calc(50% - (var(--size)) / 2 - var(--padding));
  right: 3.2rem;
  padding: var(--padding);
  display: block;
  width: min-content;
  height: min-content;
  border-radius: 4px;
  cursor: pointer;

  &::before {
    display: block;
    width: var(--size);
    height: var(--size);
    transition: 0.2s opacity;
    opacity: 0.5;
    content: url("data:image/svg+xml,%3Csvg viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12 22C9.34711 22.0024 6.80218 20.9496 4.9263 19.0737C3.05042 17.1978 1.99762 14.6529 2 12V11.8C2.08179 7.79223 4.5478 4.22016 8.26637 2.72307C11.9849 1.22597 16.2381 2.0929 19.074 4.92601C21.9365 7.78609 22.7932 12.0893 21.2443 15.8276C19.6955 19.5659 16.0465 22.0024 12 22ZM12 13.41L14.59 16L16 14.59L13.41 12L16 9.41001L14.59 8.00001L12 10.59L9.41001 8.00001L8.00001 9.41001L10.59 12L8.00001 14.59L9.41001 16L12 13.411V13.41Z' fill='white'/%3E%3C/svg%3E%0A");
  }

  &:hover::before {
    opacity: 1;
  }
`

export const SearchField = styled.input`
  ${styleReset}
  width: 100%;
  padding: 0.9rem 4rem 0.9rem 1.5rem;
  border-radius: 1rem;
  border: 1px solid #b9cccc;
  background: white
    url("data:image/svg+xml,%3Csvg width='15' height='16' viewBox='0 0 15 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M13.7219 15.6572L8.5598 10.4945C6.26343 12.127 3.09912 11.7277 1.28036 9.57592C-0.538396 7.42412 -0.404849 4.23771 1.58758 2.24562C3.57949 0.252662 6.76641 0.118546 8.91874 1.9371C11.0711 3.75566 11.4706 6.92008 9.8379 9.21651L15 14.3792L13.7228 15.6563L13.7219 15.6572ZM5.41919 2.46418C3.70635 2.4638 2.22862 3.66606 1.88067 5.34308C1.53272 7.02011 2.41019 8.71097 3.98182 9.39195C5.55345 10.0729 7.38728 9.55686 8.37305 8.1562C9.35881 6.75554 9.22556 4.85525 8.05398 3.60584L8.60045 4.14776L7.98443 3.53358L7.97359 3.52274C7.29776 2.84279 6.3779 2.4616 5.41919 2.46418Z' fill='%231A3948'/%3E%3C/svg%3E%0A")
    calc(100% - 1.5rem) 50% no-repeat;

  &:focus-visible {
    outline: none;
    border-color: var(--text-color);
  }

  &::-webkit-search-cancel-button {
    -webkit-appearance: none;
    appearance: none;
    height: 1.8rem;
    width: 1.8rem;
    cursor: pointer;
    background: url("data:image/svg+xml,%3Csvg viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12 22C9.34711 22.0024 6.80218 20.9496 4.9263 19.0737C3.05042 17.1978 1.99762 14.6529 2 12V11.8C2.08179 7.79223 4.5478 4.22016 8.26637 2.72307C11.9849 1.22597 16.2381 2.0929 19.074 4.92601C21.9365 7.78609 22.7932 12.0893 21.2443 15.8276C19.6955 19.5659 16.0465 22.0024 12 22ZM12 13.41L14.59 16L16 14.59L13.41 12L16 9.41001L14.59 8.00001L12 10.59L9.41001 8.00001L8.00001 9.41001L10.59 12L8.00001 14.59L9.41001 16L12 13.411V13.41Z' fill='%231A3948'/%3E%3C/svg%3E%0A")
      center center / contain no-repeat;
  }
`

export const Options = styled(motion.ul)`
  list-style: none;
  margin: 0;
  padding: 0;
  max-height: 18rem;
  overflow-y: scroll;
  scrollbar-width: none;
  overscroll-behavior: contain;

  ${mq.medium} {
    max-height: calc(100% - 4.7rem);
  }

  &::-webkit-scrollbar {
    display: none;
  }

  &::before {
    content: '';
    position: sticky;
    top: 0;
    display: block;
    border-top: 1px solid currentColor;
    margin-bottom: 0.5em;
  }

  &::after {
    content: '';
    display: block;
    height: 0.5em;
  }

  > li {
    padding: 0;
    margin: 0 3rem;

    &:not(:last-child) {
      border-bottom: 1px solid rgba(255, 255, 255, 0.6);
    }
  }
`

export const Cols = styled.span`
  display: flex;
  justify-content: space-between;
`

export const Subfilters = styled(Options)`
  margin-left: 1em;
  max-height: none;
  overflow-y: visible;

  &::before {
    display: none;
  }

  li {
    margin: 0;
  }
`

export const FilterToggle = styled.button`
  ${styleReset}
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 0.5rem 0.8rem;
  margin: 0.2rem -0.8rem;
  box-sizing: content-box;
  border-radius: 0.4em;

  &:disabled {
    opacity: 0.5;
  }

  &:not(:disabled) {
    cursor: pointer;
    transition: 0.2s background-color;

    &:hover {
      background-color: rgba(255, 255, 255, 0.15);
    }
  }

  &:not(:last-child) {
    margin-right: 0.2rem;
  }
`

export const SubfilterToggle = styled(FilterToggle)`
  margin-left: 0;
  width: max-content;

  &::after {
    content: '';
    display: inline-block;
    vertical-align: middle;
    width: 0.8rem;
    height: 0.8rem;
    margin: 0.24em auto 0 0.4em;
    border-right: 2px solid currentColor;
    border-bottom: 2px solid currentColor;
    transform: rotate(45deg);
    transition: 0.3s transform;
  }

  &[data-expanded='true']::after {
    transform: translateY(40%) rotate(225deg);
  }
`
export const Divider = styled.div`
  height: 1px;
  background: var(--text-color);
  margin: 6px 0 0 0;
`

export const Summary = styled.li`
  text-align: left;
  scroll-margin: 2rem;
  font-size: 1.8rem;

  span {
    font-weight: 800;
  }

  ${mq.large} {
    font-size: 2.1rem;
  }
`
